<h2 mat-dialog-title>
  <mat-icon>list</mat-icon>
  Sessioner for {{ paymentTerminal.serialNumber }}

  <span>
    @if (paymentTerminal.chargingStationLocationInfo) {
      {{ paymentTerminal.chargingStationLocationInfo.chargingStationLocationName }} -
      {{ paymentTerminal.chargingStationLocationInfo.chargingStationLocationFullAddress }}
    }
    @if (!paymentTerminal.chargingStationLocationInfo) {
      ingen tilknyttede lokationer
    }
  </span>
</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  <adm-loading-spinner
    [loading$]="loading$"
    [hasNoData]="(data$ | async) === null && (loading$ | async) === false"
    [noResultsMessage]="'Noget gik galt, da der blev forsøgt at hente sessions'"></adm-loading-spinner>
  <table
    #terminalSessionList
    mat-table
    [dataSource]="data$"
    [class.loading-blur]="loading$ | async"
    [class.loading-blur--done]="(loading$ | async) === false"
    class="terminal-session-table"
    matSort
    (matSortChange)="sortData($event)"
    multiTemplateDataRows>
    <ng-container matColumnDef="updated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">Tidspunkt</th>
      <td mat-cell *matCellDef="let terminalSession" class="row" title="{{ terminalSession.updated | date: 'dd.MM.yyyy HH:mm:ss' }}">
        {{ terminalSession.updated | date: 'short' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">Status</th>
      <td mat-cell *matCellDef="let terminalSession" class="row">
        {{ terminalSession.status }}
      </td>
    </ng-container>
    <ng-container matColumnDef="payterSessionId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">Payter SessionId</th>
      <td mat-cell *matCellDef="let terminalSession" class="row">
        {{ terminalSession.payterSessionId !== null ? terminalSession.payterSessionId : '-' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="chargingToken">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">Charging token</th>
      <td mat-cell *matCellDef="let terminalSession" class="row">
        {{ terminalSession.chargingToken !== null ? terminalSession.chargingToken : '-' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="commitTimestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">Commit tidspunkt</th>
      <td
        mat-cell
        *matCellDef="let terminalSession"
        class="row"
        title="{{ terminalSession.commitTimestamp | date: 'dd.MM.yyyy HH:mm:ss' }}">
        {{ terminalSession.commitTimestamp | date: 'short' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell class="align-right" *matCellDef="let terminalSession">
        <button
          class="action-button"
          mat-icon-button
          aria-label="Detaljer"
          (click)="expandedTerminalSession = terminalSession.id === expandedTerminalSession?.id ? null : terminalSession">
          <mat-icon>
            {{ terminalSession.id === expandedTerminalSession?.id ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell class="expanded-detail" *matCellDef="let terminalSession" [attr.colspan]="displayColumns.length">
        <div class="json" [@detailExpand]="terminalSession === expandedTerminalSession ? 'expanded' : 'collapsed'">
          <pre>{{ expandedTerminalSession | json }}</pre>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let rowData; columns: displayColumns" [class.highlight]="rowData.highlight | async"></tr>

    <tr mat-row *matRowDef="let rowData; columns: ['expandedDetail']" class="expanded-row"></tr>
  </table>

  @if ((data$ | async)?.length === 0 && (loading$ | async) === false) {
    <div class="no-results align-center">
      <p>Der blev ikke fundet nogen sessions</p>
    </div>
  }
  <mat-paginator
    #paginator
    [pageIndex]="currentPage"
    [pageSize]="pagingOptions.pageSize"
    [length]="terminalSessionCount"
    [pageSizeOptions]="pagingOptions.pageSizeOptions"
    (page)="pageSwitch($event)"
    color="accent"
    [disabled]="(loading$ | async) === true"></mat-paginator>
</mat-dialog-content>

<mat-dialog-actions>
  @if (paymentTerminal) {
    <div class="unit-identifier">
      <span>Terminal serienummer</span>
      {{ paymentTerminal.serialNumber }}
    </div>
  }

  <button class="actions__button" type="button" mat-dialog-close mat-button (click)="close()">Luk</button>
</mat-dialog-actions>
